<template>
  <main class="bg_gray" style="height: calc(100vh - 49px)">
    <div id="error_page">
      <div class="container">
        <div class="row justify-content-center text-center">
          <div class="col-xl-7 col-lg-9">
            <figure>
              <img
                src="../assets/img/404.svg"
                alt=""
                class="img-fluid"
                width="550"
                height="234"
              />
            </figure>
            <p>{{ $t('error.404') }}</p>
           
          </div>
        </div>
        <!-- /row -->
      </div>
      <!-- /container -->
    </div>
    <!-- /container -->
  </main>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({
  props: {
    msg: String,
  },
  data() {
    return {};
  },
  computed: {},
  methods: {},

  components: {},
})
export default class NotFoundComp extends Vue {
  msg!: string;
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
